export const education = {
  heading: "EDUCATION",
  subheading: "Diploma : Computer & Communication Engineering",
  department:
    "Department Of Electrical And Computer Engineering (University of Thessaly)",
  place: "Volos / Greece",
  date: "09/2011 - 11/2019",
};
